import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import * as BaseComp from 'components/bolt/footer/footer.js';
import Button from 'components/bolt/button/button';
import Close from 'components/bolt/icons/close';

import s from 'components/bolt/footer/footer.sss';


export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
	}

	renderSocialLinks(socialLinks) {
		if (!socialLinks) return null;

		const items = Object.values(socialLinks)
			.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
			.slice(0, 10);

		return (
			<div class={s.socialLinks}>
				{items.map(item => (
					<a
						href={item.link}
						target="_blank"
						rel="noopener noreferrer"
						class={s.socialLink}
					>
						{item.name}
					</a>
				))}
			</div>
		);
	}

	renderOpenFooter() {
		const {
			logos,
			links,
			copyright,
			socialLinks
		} = this.footerData;

		const footerBgStyling = accessNested(Store.get(), 'appData.styling.variables.footerBgColor', this.state.backgroundColor);
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});


		const autoExpanding = this.state.autoExpanding;

		const footerStyle = {
			background: !this.pressKitFooter && footerBgStyling
		};

		return (
			<div class={joinClasses(s.openWrapper, autoExpanding && s.autoExpanding)} style={footerStyle}>
				<Button
					class={s.closeBtn}
					trigger={autoExpanding ? this.cancelAutoExpanding : this.toggleFooter}
					ariaLabel={accessibilityCopy.$COLLAPSE_FOOTER_ARIA}
				>
					<Close />
				</Button>
				<div class={joinClasses(s.studioDetails)}>
					{this.renderSocialLinks(socialLinks)}
					{this.getLogos(logos)}
					<div class={s.line} />
					<ul class={s.links}>
						{this.renderLinks(links, 'link')}
					</ul>
				</div>
				<ul class={joinClasses(s.copyright, this.fontStyles.footerCopyright)}>
					{this.renderLinks(copyright, 'copyright')}
				</ul>
			</div>
		);
	}

}